(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire06a3"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire06a3"] = parcelRequire;
}
parcelRequire.register("67vMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0126634dfaac58f4$export$6503ec6e8aabbaf; }, function (v) { return $0126634dfaac58f4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0126634dfaac58f4$export$f7ad0328861e2f03; }, function (v) { return $0126634dfaac58f4$export$f7ad0328861e2f03 = v; });
var $0126634dfaac58f4$export$6503ec6e8aabbaf;
var $0126634dfaac58f4$export$f7ad0328861e2f03;
"use strict";
var $0126634dfaac58f4$var$mapping = {};
function $0126634dfaac58f4$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0126634dfaac58f4$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0126634dfaac58f4$var$resolve(id) {
    var resolved = $0126634dfaac58f4$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0126634dfaac58f4$export$6503ec6e8aabbaf = $0126634dfaac58f4$var$register;
$0126634dfaac58f4$export$f7ad0328861e2f03 = $0126634dfaac58f4$var$resolve;

});

var $03c6596b95bedb6c$exports = {};

(parcelRequire("67vMA")).register(JSON.parse('{"3cSMf":"index.ca6ea015.js","2vYwK":"earth.1cb632e3.png","f6Vv9":"space.1473ddc3.png","hR47J":"index.ff550e58.css"}'));

})();
//# sourceMappingURL=index.0af53eb8.js.map
